import { getMerchantStructureByMerchantId } from '@nemuru-eng/js-api-client';
import { useMemo } from 'react';

import MerchantStructureEntity from '@/entities/MerchantStructureEntity';
import { useCache } from '@/hooks/requests/useCache';

export const useGetMerchantStructureById = (merchantId: string) => {
  const {
    data: merchantStructure,
    loading,
    error,
    revalidate,
  } = useCache(getMerchantStructureByMerchantId, { merchantId });

  const sortedMerchantStructure = useMemo(
    () => (merchantStructure ? MerchantStructureEntity.getSortedStructure(merchantStructure) : undefined),
    [merchantStructure],
  );

  return { merchantStructure: sortedMerchantStructure, loading, error, revalidate };
};
